// extracted by mini-css-extract-plugin
module.exports = {"option":"mui_autocomplete_option__1C3nx","clearIndicator":"mui_autocomplete_clearIndicator__3CGSp"};